import { toast } from "react-toastify"
import PnLBudgetAPI from "../../../api/pnlBudget"
import { transformReportingDetailData } from "./utils"
import { useResponseHandle } from "../../hooks"

const pnlReportingAPI = new PnLBudgetAPI()

export const getPnlReportingData = async (params: any) => {
  const { dispatch, setLoading, token, data } = params
  const { tClass, years, months, group } = data

  if (token) {
    setLoading(true)
    let data = {
      group_sk: group?.group_sk,
      class_id: tClass?.class_id,
      budget_year: years?.label,
      month_list: months,
    }
    const result = await pnlReportingAPI.getPnlTableData(token, data)

    if (result?.data?.status_code != 200 && result?.data?.status_code != 401) {
      toast.error(result?.data?.display_message)
    } else {
      dispatch(result?.data?.data?.budget_vs_actual_data)
    }

    setLoading(false)
  }
}

export const getPnlDetailData = async (params: any) => {
  const { dispatch, setLoading, token, data } = params
  const { lineItem, group, tClass, years, months } = data

  if (token) {
    setLoading(true)
    const payload = {
      line_item: lineItem.toUpperCase(),
      group_sk: group?.group_sk,
      transaction_class: tClass?.transaction_class,
      year: years?.label,
      months,
    }

    const result = await pnlReportingAPI.getPnlTableDataByLineItem(
      token,
      payload,
    )

    if (result?.data?.status_code != 200 && result?.data?.status_code != 401) {
      toast.error(result?.data?.display_message)
    } else {
      dispatch(
        transformReportingDetailData(result?.data?.data?.account_list || []),
      )
    }
  }
  setLoading(false)
}

export const getTransactionDetailData = async (params: any) => {
  const { dispatch, setLoading, token, data } = params
  const { lineItem, group, tClass, years, months } = data
  const { account, accountClass, accountSubClass } = data

  if (token) {
    setLoading(true)
    const payload = {
      line_item: lineItem.toUpperCase(),
      group_sk: group?.group_sk,
      transaction_class: tClass.transaction_class,
      year: years?.label,
      months,
      account,
      account_class: accountClass,
      account_sub_class: accountSubClass === "-----" ? "" : accountSubClass,
    }

    const result = await pnlReportingAPI.getPnlTransactionData(token, payload)

    if (result?.data?.status_code != 200 && result?.data?.status_code != 401) {
      toast.error(result?.data?.display_message)
    } else {
      dispatch(result?.data?.data?.transactions || [])
    }

    setLoading(false)
  }
}

// Filters

export const getAvailableYears = async (params: any) => {
  const { dispatch, loading, token, group, navigate } = params
  if (token) {
    loading(true)
    const response = await pnlReportingAPI.getReportingYears(
      token,
      group?.group_sk,
    )
    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })
    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        const years = result?.data?.map((year: any) => ({
          label: year,
        }))
        
        // Sort years in descending order (most recent first)
        years.sort((a: any, b: any) => {
          const yearA = parseInt(a.label)
          const yearB = parseInt(b.label)
          return yearB - yearA
        })
        
        dispatch(years)
      }
      loading(false)
    } else {
      loading(false)
      navigate("/auth")
    }
    loading(false)
  }
}

export const getClasses = async (params: any) => {
  const { dispatch, loading, token, group, navigate, years, months } = params
  if (token) {
    loading(true)
    const response = await pnlReportingAPI.getPnlClasses(
      token,
      group.group_sk,
      years,
      months,
    )
    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
      hideError: false,
    })
    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        dispatch(result?.data)
      }
      loading(false)
    } else {
      loading(false)
      navigate("/auth")
    }
    loading(false)
  }
}
